// `_matcher` : an utility's function
// -----------------------------------

// The cornerstone, a `matcher` implementation, aka `matches`.
export {default} from './matches'; 